import { render } from "./PrPlanDetails.vue?vue&type=template&id=5568f910&scoped=true"
import script from "./PrPlanDetails.vue?vue&type=script&lang=js"
export * from "./PrPlanDetails.vue?vue&type=script&lang=js"

import "./PrPlanDetails.vue?vue&type=style&index=0&id=5568f910&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5568f910"]])

export default __exports__